import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { KeyUri } from "../key";

const HotelBookingDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);

  
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [submittingReview, setSubmittingReview] = useState(false);
  const [reviewSubmitted, setReviewSubmitted] = useState(false);
  const [existingReview, setExistingReview] = useState(null);

   const [cancelModal, setCancelModal] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [cancelResult, setCancelResult] = useState(null);

  const fetchBooking = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("tokenUser"));
      
    
      const res = await axios.get(
        `${KeyUri.BACKEND_URI}/hotelbookings/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const bookingData = res.data.data || res.data;
      setBooking(bookingData);

      
      const reviewRes = await axios.get(
        `${KeyUri.BACKEND_URI}/properties/${bookingData.propertyId._id}/reviews`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

     

      const reviewsArray = reviewRes.data?.reviews || [];
      
     
      const userReview = reviewsArray.find((rev) => {
        const reviewBookingId = rev.bookingId?._id?.toString() || rev.bookingId?.toString();
        return reviewBookingId === bookingData._id.toString() || 
               rev.userId?._id?.toString() === bookingData.userId?.toString();
      });

    

      if (userReview) {
        setExistingReview(userReview);
        setReviewSubmitted(true);
        
        setRating(userReview.rating);
        setComment(userReview.comment || "");
      }
    } catch (error) {
      console.error("Error fetching hotel booking:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBooking();
  }, [id]);

  const handleCancel = () => {
    setCancelModal(true); 
  };

  const confirmCancel = async () => {
    try {
      setCancelLoading(true);
      const token = JSON.parse(localStorage.getItem("tokenUser"));

      const response = await axios.post(
        `${KeyUri.BACKEND_URI}/hotel/cancel-booking`,
        {
          bookingId: booking._id,
          paymentId: booking.razorpayPaymentId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

     
      setCancelResult(response.data);
      setCancelModal(false);
      fetchBooking(); 
    } catch (error) {
      console.error("Cancel failed:", error.response?.data || error);
      alert(error.response?.data?.error || "Cancellation failed");
    } finally {
      setCancelLoading(false);
    }
  };

  
  const handleSubmitReview = async () => {
    try {
      if (rating === 0) {
        alert("Please select a rating");
        return;
      }
      if (!comment?.trim()) {
        alert("Please add a comment");
        return;
      }

      setSubmittingReview(true);
      const token = JSON.parse(localStorage.getItem("tokenUser"));

      await axios.post(
        `${KeyUri.BACKEND_URI}/properties/${booking.propertyId._id}/reviews`,
        {
          bookingId: booking._id,
          rating,
          comment: comment.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      await fetchBooking(); 
      alert("Review submitted successfully!");
    } catch (error) {
      console.error("Review submission failed:", error);
      alert("Failed to submit review");
    } finally {
      setSubmittingReview(false);
    }
  };

  if (loading) return <p className="text-center mt-10">Loading...</p>;
  if (!booking) return <p className="text-center mt-10">Booking not found</p>;

  const nights = (new Date(booking.checkOut) - new Date(booking.checkIn)) / (1000 * 60 * 60 * 24);

  
  const today = new Date();
  const checkInDate = new Date(booking.checkIn);
  const checkOutDate = new Date(booking.checkOut);
  const canReview = booking.status === "confirmed" && today >= checkOutDate && !existingReview;

    const canCancel =
    booking.status === "confirmed" &&
    booking.razorpayPaymentId &&
    today < checkInDate &&
    (() => {
      try {
        const tokenData = JSON.parse(localStorage.getItem("tokenUser") || "{}");
        return booking.userId?._id === tokenData.id;
      } catch {
        return false;
      }
    })();

  return (
    <div className="max-w-5xl mx-auto p-6 space-y-6 mt-32 mb-10">
      {/* 🏨 Property Banner */}
        <div className="p-4 max-w-xl mr-80">
         <button
        onClick={() => navigate(-1)}
        className="text-gray-600 hover:text-gray-800 hidden md:block mr-100"
      >
        ← Go Back
      </button>
      </div> 

      <div className="bg-white rounded-xl shadow p-6">
        <h1 className="text-2xl font-bold">{booking.propertyId?.propertyName}</h1>
        <p className="text-gray-600">
          {booking.propertyId?.location?.city}, {booking.propertyId?.location?.state}
        </p>
        <p className="text-sm text-gray-500 mt-2">Booking ID: {booking.bookingId || booking._id}</p>
      </div>

      {/* 📅 Booking Details */}
      <div className="bg-white rounded-xl shadow p-6">
        <h2 className="text-lg font-semibold mb-4">Stay Details</h2>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-gray-500">Check-In</p>
            <p className="font-medium">{new Date(booking.checkIn).toLocaleDateString()}</p>
          </div>
          <div>
            <p className="text-gray-500">Check-Out</p>
            <p className="font-medium">{new Date(booking.checkOut).toLocaleDateString()}</p>
          </div>
          <div>
            <p className="text-gray-500">Nights</p>
            <p className="font-medium">{nights}</p>
          </div>
          <div>
            <p className="text-gray-500">Guests</p>
            <p className="font-medium">{booking.guests}</p>
          </div>
          <div>
            <p className="text-gray-500">Room Type</p>
            <p className="font-medium">{booking.accommodationId?.title}</p>
          </div>
          <div>
            <p className="text-gray-500">Rooms Booked</p>
            <p className="font-medium">{booking.accommodationQuantity}</p>
          </div>
        </div>
      </div>

      {/* 👤 Guest Info */}
      <div className="bg-white rounded-xl shadow p-6">
        <h2 className="text-lg font-semibold mb-4">Guest Details</h2>
        <p><strong>Name:</strong> {booking.firstName} {booking.lastName}</p>
        <p><strong>Email:</strong> {booking.email}</p>
        <p><strong>Phone:</strong> {booking.phone}</p>
        {booking.specialRequests && (
          <p><strong>Special Requests:</strong> {booking.specialRequests}</p>
        )}
      </div>

      {/* 💳 Payment Info */}
      <div className="bg-white rounded-xl shadow p-6">
        <h2 className="text-lg font-semibold mb-4">Payment Details</h2>
        <p><strong>Amount Paid:</strong> ₹{booking.amountPaid}</p>
        <p>
          <strong>Status:</strong>{" "}
          <span
            className={`px-3 py-1 rounded-full text-sm ${
              booking.status === "confirmed"
                ? "bg-green-100 text-green-700"
                : booking.status === "cancelled"
                ? "bg-red-100 text-red-700"
                : "bg-yellow-100 text-yellow-700"
            }`}
          >
            {booking.status}
          </span>
        </p>
      </div>

      {/* ⭐ REVIEW SECTION (Identical to Wellness) */}
      {canReview && (
        <div className="bg-white rounded-xl shadow p-6">
          <h3 className="text-lg font-semibold mb-4">Leave a Review</h3>
          
          {/* Star Rating */}
          <div className="flex space-x-2 mb-4">
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                onClick={() => setRating(star)}
                className={`text-3xl transition ${
                  star <= rating ? "text-yellow-400" : "text-gray-300"
                }`}
              >
                ★
              </button>
            ))}
          </div>

          <textarea
            rows="4"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Share your stay experience..."
            className="w-full border rounded-lg p-3 mb-4 focus:outline-none focus:ring-2 focus:ring-yellow-400"
          />

          <button
            onClick={handleSubmitReview}
            disabled={submittingReview}
            className="bg-black text-white px-6 py-2 rounded-lg hover:opacity-90 disabled:opacity-50"
          >
            {submittingReview ? "Submitting..." : "Submit Review"}
          </button>
        </div>
      )}

      {reviewSubmitted && (
        <div className="bg-green-50 border border-green-200 text-green-700 p-4 rounded-lg">
          Thank you! Your review has been submitted.
        </div>
      )}

      {existingReview && (
        <div className="bg-white rounded-xl shadow p-6">
          <h3 className="text-lg font-semibold mb-4">Your Review</h3>
          <div className="text-yellow-400 text-2xl mb-2">
            {"★".repeat(existingReview.rating)}
            {"☆".repeat(5 - existingReview.rating)}
          </div>
          <p className="text-gray-700">{existingReview.comment}</p>
        </div>
      )}

      {/* Cancel Button */}
 
   {canCancel && (
        <div className="text-right mb-6">
          <button
            onClick={handleCancel}
            className="bg-red-500 hover:bg-red-600 text-white px-8 py-3 rounded-lg font-semibold shadow-lg hover:shadow-xl transition-all"
          >
            Cancel Booking
          </button>
        </div>
      )}

{cancelModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-2xl p-8 max-w-md w-full max-h-[90vh] overflow-y-auto">
      <div className="text-center mb-6">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">Cancel Booking?</h3>
        <p className="text-gray-600">This action cannot be undone. Are you sure?</p>
      </div>

      <div className="space-y-4">
        <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg">
          <p className="text-sm text-yellow-800 font-medium">
            <strong>Refund Policy:</strong>
          </p>
          <p className="text-xs text-yellow-700 mt-1">
            {(() => {
              const checkInDate = new Date(booking.checkIn);
              const todayDate = new Date();
              const daysDiff = (checkInDate - todayDate) / (1000 * 60 * 60 * 24);
              return daysDiff >= 7
                ? `50% refund (₹${Math.round(booking.amountPaid * 0.5)})`
                : "No refund within 7 days of check-in";
            })()}
          </p>
        </div>

        <div className="flex gap-3 pt-4">
          <button
            onClick={() => setCancelModal(false)}
            className="flex-1 bg-gray-200 text-gray-800 px-6 py-3 rounded-xl font-semibold hover:bg-gray-300 transition-all"
            disabled={cancelLoading}
          >
            Cancel
          </button>
          <button
            onClick={confirmCancel}
            disabled={cancelLoading}
            className="flex-1 bg-red-500 text-white px-6 py-3 rounded-xl font-semibold hover:bg-red-600 disabled:opacity-50 transition-all"
          >
            {cancelLoading ? "Cancelling..." : "Yes, Cancel"}
          </button>
        </div>
      </div>
    </div>
  </div>
)}


{cancelResult && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center">
      <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <svg className="w-12 h-12 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h3 className="text-2xl font-bold text-gray-900 mb-4">Booking Cancelled!</h3>
      <p className="text-gray-600 mb-6">
        Reference: <strong>{cancelResult.bookingRef || booking.bookingId || booking._id}</strong>
      </p>
      
      {cancelResult?.refundAmount > 0 ? (
        <div className="bg-green-50 border border-green-200 p-6 rounded-xl mb-6">
          <p className="text-lg font-semibold text-green-800 mb-2">Refund Processing</p>
          <p className="text-green-700">
            ₹{cancelResult.refundAmount} will be refunded to your original payment method
          </p>
          {cancelResult.refundId && (
            <p className="text-sm text-green-600 mt-2">Refund ID: {cancelResult.refundId}</p>
          )}
        </div>
      ) : (
        <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg mb-6">
          <p className="text-yellow-800">No refund as cancellation was within 7 days</p>
        </div>
      )}
      
      <div className="flex gap-3">
        <button
          onClick={() => {
            setCancelResult(null);
          }}
          className="flex-1 bg-gray-500 text-white px-6 py-3 rounded-xl font-semibold hover:bg-gray-600"
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default HotelBookingDetail;
